<template>
    <v-card>
        <v-data-table :headers="headers" :items="configurazioni" :key="key_tabella">
            <template v-slot:top>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text">
                        Configurazione macchine
                    </v-toolbar-title>
                    <v-spacer></v-spacer>

                    <!-- Bottone di modifica -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn @click="dialog_modifica = true" small v-bind="attrs" v-on="on">
                                <v-icon color="primary"> mdi-plus </v-icon>
                            </v-btn>
                        </template>
                        <span>Aggiungi Configurazione</span>
                    </v-tooltip>

                    <v-spacer></v-spacer>

                    <!-- Bottone per tornare indietro -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn @click="clickBack" small v-bind="attrs" v-on="on">
                                <v-icon color="error"> mdi-keyboard-backspace </v-icon>
                            </v-btn>
                        </template>
                        <span>Indietro</span>
                    </v-tooltip>
                </v-toolbar>
            </template>
            <!-- Bottone di modifica -->
            <template v-slot:[`item.modifica`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mr-5" @click="modificaConfig(item)" small
                            v-bind="attrs" v-on="on">
                            <v-icon color="primary"> mdi-pencil </v-icon>
                        </v-btn>
                    </template>
                    <span>Modifica</span>
                </v-tooltip>
            </template>

            <!-- Bottone di eliminazione -->
            <template v-slot:[`item.elimina`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mr-5" @click="configurazione_sel = item; conferma_elimina = true" small
                            v-bind="attrs" v-on="on">
                            <v-icon color="error"> mdi-close </v-icon>
                        </v-btn>
                    </template>
                    <span>Elimina</span>
                </v-tooltip>
            </template>
        </v-data-table>

        <!-- Dialog di aggiunta / modifica -->
        <v-dialog v-model="dialog_modifica" max-width="800px">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text">
                        Configurazione
                    </v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn @click="salvaConfigurazione(); setMacchineElementi()" small v-bind="attrs" v-on="on">
                                <v-icon color="success">mdi-floppy</v-icon>
                            </v-btn>
                        </template>
                        <span>Salva</span>
                    </v-tooltip>

                    <v-spacer></v-spacer>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn @click="dialog_modifica = false; configurazione_sel = {}; lista_elementi_tipo = [];
                        lista_report_selezionati = [];" small v-bind="attrs" v-on="on">
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text style="overflow-y: auto">
                    <v-container>
                        <v-row align="center" justify="center">
                            <v-col align="center" cols="6">
                                
                                    <v-autocomplete background-color="#ffffff" hide-details :items="tipi_macchina"
                                        item-text="des" item-value="id_tabella" label="Tipo macchina"
                                        v-model="configurazione_sel.id_tipo">
                                    </v-autocomplete>
                
                            </v-col>
                            <v-col align="center" cols="6">
                                <v-autocomplete background-color="#ffffff" multiple hide-details :items="lista_report" item-text="cod_report" return-object label="Report"
                                     v-model="lista_report_selezionati">
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                  <v-toolbar color="indigo" dense class="mt-5">
                    <v-toolbar-title class="white--text">
                        Elementi manutenzione
                    </v-toolbar-title>

                </v-toolbar>
                    <v-row align="center" justify="center" class="pt-1">
                        
                        <v-col :cols="10">
                            <v-select
                                        v-model="elemento_sel"
                                        itemText="des"
                                        itemValue="id_tabella"
                                        :items="lista_elementi"
                                        append-icon="fa fa-caret-down"
                                        :searchbox="true"
                                    >
                                        <template v-slot:label>
                                            <span style="display: inline"
                                                >Elementi
                                            </span>
                                            <span
                                                style="
                                                    min-width: 50px;
                                                    min-height: 15px;
                                                    pointer-events: all;
                                                    display: inline-block;
                                                "
                                                @click.stop
                                            >
                                                <Modules
                                                    v-on:dialogModules="
                                                        getTabelle
                                                    "
                                                    tipo="MACCHINA_ELEMENTI"
                                                    nome="Elementi macchina manutenzione"
                                                    setaction="settabelle"
                                                    getaction="gettabelle"
                                                    controller="Magazzino"
                                                    filter="validita = 1"
                                                    :dati="[{ des: '' }]"
                                                />
                                            </span>
                                        </template>
                                    </v-select>
                        </v-col>
                        <v-col :cols="2">
                            <v-btn
                                
                                color="white"
                                style="margin-top: 5px"
                                font-color="rgb(0, 102, 255)"
                                @click="aggiungiElemento"
                                title="Aggiungi"
                                width="73px" ><v-icon color="primary"> mdi-plus </v-icon></v-btn></v-col
                    ></v-row>
                    <v-row
                        align="center"
                        justify="center"
                        style="margin-top: 10px"
                    >
                        <v-col :cols="12">
                            <v-data-table
                                :headers="headers_elementi"
                                :items="
                                    lista_elementi_tipo.filter((e) => e.validita == 1)
                                "
                            >
                                <!-- Colonna dell'eliminazione -->
                                <template v-slot:[`item.delete`]="{ item }">
                                    <v-btn
                                        color="white"
                                        @click="item.validita = 0"
                                        title="Elimina"
                                        font-color="rgb(204, 0, 0)"
                                    > <v-icon color="error">mdi-close</v-icon></v-btn>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    </v-container>
                </v-card-text>
            </v-card>

            <!-- Overlay di caricamento per il salvataggio -->
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-dialog>

        <!-- Dialog di conferma eliminazione -->
        <v-dialog v-model="conferma_elimina" width="unset">
            <v-card style="max-width: 500px">
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
                </v-toolbar>
                <v-card-text class="mt-5" style="overflow-y: auto">
                    <span style="color: rgb(0, 0, 0); font-size: 18px">
                        Confermi di voler eliminare la configurazione?
                    </span>
                    <v-divider class="my-5"></v-divider>
                    <v-container>
                        <v-row align="center" justify="center">
                            <v-col class="my-0 py-0" justify="center" cols="12">
                                <v-btn class="mr-5" @click="conferma_elimina = false" small>
                                    <v-icon color="error"> mdi-close </v-icon>
                                </v-btn>

                                <v-btn @click="eliminaConfigurazione" small>
                                    <v-icon color="success"> mdi-check </v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>

            <!-- Overlay di caricamento per l'eliminazione -->
            <v-overlay :value="overlay_cancellazione">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-dialog>

        <!-- Overlay di caricamento -->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <!-- Snackbar -->
        <SnackbarQV ref="SnackbarQV" />
    </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import Modules from "@/components/TOOLS/Modules.vue";
import moment from "moment/moment";


export default {
    name: "ConfigurazioneMacchine",
    components: { SnackbarQV, Modules },
    props: {},
    data() {
        return {
            // Variabili d'appoggio
            configurazione_sel: {},
            key_tabella:false,
            elemento_sel: {},

            // Modal
            conferma_elimina: false,
            dialog_modifica: false,
            overlay: false,
            overlay_cancellazione: false,

            // Array
            configurazioni_totali: [],
            configurazioni: [],
            lista_elementi: [],
            lista_elementi_tipo: [],
            headers: [
                {
                    text: "Modifica",
                    value: "modifica",
                    sortable: false,
                    width: "150px",
                },
                {
                    text: "Tipo macchina",
                    value: "des_tipo",
                    sortable: false,
                    width: "150px",
                },

                { text: "Elimina", value: "elimina", sortable: false, width: "150px" },
            ],

            headers_elementi: [
                { text: "Descrizione", value: "descrizione" },
                { text: "Elimina", width: "60px", value: "delete" },
            ],
            tipi_macchina: [],
            lista_report: [],
            lista_report_selezionati: [],
        };
    },
    computed: {},
    watch: {
        variabile: {
            immediate: true,
            handler() { },
        },
    },
    methods: {

        clickBack() {
            this.$emit("click_chiudi");
        },

        modificaConfig(item){
            this.configurazione_sel = item; 
            this.configurazioni_totali.forEach((ct)=>{
                if(ct.id_tipo == item.id_tipo){
                    this.lista_report_selezionati.push({
                        id_macchina_docs: ct.id_macchina_docs,
                        id_report: ct.id_rif,
                        cod_report: ct.cod_report
                    });
                }
            });
            this.getMacchinaElementi();
            this.dialog_modifica = true
        },

        eliminaConfigurazione() {
            let temp_config = [];
            this.configurazioni_totali.forEach((ct)=>{
                if(ct.id_tipo == this.configurazione_sel.id_tipo){
                    ct.validita = 0;
                    temp_config.push(ct);
                }
            });

        
            let request = {
                method: "PUT",
                controller: "magazzino",
                richiesta: {
                    action: "setmacchinadocs",
                    token: localStorage.user_token,
                    configurazioni: temp_config,
                },
            };

            this.overlay = true;
            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    if (res.status === 200) {
                        this.overlay = false;
                        this.configurazione_sel = {};
                        this.conferma_elimina = false;
                        // Stampo una snackbar di conferma
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Risorsa rimossa con successo!"
                        );

                        // Aggiorno i dati della tabella
                        this.getConfigurazioni();
                    } else {
                        this.overlay = false;
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore nella comunicazione col server."
                        );
                    }
                })
                .catch(() => {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore critico nella comunicazione col server."
                    );
                });
        },

        async getReport() {
            const request = {
                controller: "global",
                method: "POST",
                richiesta: {
                    action: "getreport",
                    compact_response: true,
                    token:  localStorage.user_token,
                },
            };

            this.caricamento_dati = true;

            return this.$store
                .dispatch("api6", request)
                .then((res) => {
                    this.caricamento_dati = false;
                    if (res.data.statusCode === 200) {
                        this.lista_report = res.data.result.report ? res.data.result.report : [];
                        if (this.lista_report) {
                            this.lista_report.sort((a, b) => a.cod_report - b.cod_report);
                        }
                        return true;
                    } else {
                        console.log("error: " + res.data.statusCode);
                        return false;
                    }
                })
                .catch((err) => {
                    this.caricamento_dati = false;
                    // Stampo una snackbar di avviso.
                    this.$refs.SnackbarQV.print("error", "Errore di comunicazione col server, non è stato possibile caricare i dati."); // Stampo il log dell'errore in console.
                    console.error(err);
                    return false;
                });
        },

        aggiungiElemento() {
            let elemento = this.lista_elementi.filter(
                (e) => e.id_tabella == this.elemento_sel
            )[0];
            elemento.id_macchina_elemento_manutenzione = -1;
            elemento.id_tipo_macchina_elemento_manutenzione = this.elemento_sel;
            elemento.id_tipo_macchina = this.configurazione_sel.id_tipo;
            elemento.descrizione = elemento.des;
            elemento.validita = 1;
            this.lista_elementi_tipo.push(elemento);
            this.elemento_sel = {};
        },

        getTabelle() {
            const request = {
                controller: "global",
                method: "POST",
                richiesta: {
                    action: "gettabella",
                    token: localStorage.user_token,
                    tipo: "'TIPO_GET_MACCHINA',  'MACCHINA_ELEMENTI'",
                },
            };

            this.overlay = true;

            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    this.overlay = false;
                    if (res.status === 200) {
                        this.tipi_macchina = res.data.result.TIPO_GET_MACCHINA;
                        this.lista_elementi = res.data.result.MACCHINA_ELEMENTI;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile aggiornare i dati."
                        );
                    }
                })
                .catch((e) => {
                    this.overlay = false;
                    console.error(e);
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Errore di comunicazione col server, non è stato possibile aggiornare i dati."
                    );
                });
        },

        getConfigurazioni() {

            const request = {
                controller: "magazzino",
                method: "POST",
                richiesta: {
                    action: "getmacchinadocs",
                    token: localStorage.user_token,
                },
            };

            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    if (res.status === 200) {
                        // Resetto l'array
                        this.configurazioni = [];
                        this.configurazioni_totali= res.data.result;
                        res.data.result.forEach((r)=>{
                            if(!this.configurazioni.find(({id_tipo})=> id_tipo == r.id_tipo)){
                                this.configurazioni.push(r);
                            }
                        });
                        this.key_tabella = !this.key_tabella;

                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore nello scambio di dati col server."
                        );
                    }
                })
                .catch((err) => {
                    if (err) {
                        console.error(err);
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Errore nello scambio di dati col server."
                        );
                    }
                });

        },

        setMacchineElementi() {

            this.caricamento_dati = true;
            let richiesta = {
                controller: "magazzino",
                method: "PUT",
                richiesta: {
                    action: "setmacchineelemento",
                    token: localStorage.user_token,
                    elementi_macchina: this.lista_elementi_tipo,
                },
            };
            this.$store
                .dispatch("api6", richiesta)
                .then((res) => {
                    console.log(res);
                    this.lista_elementi_tipo = [];
                })
                .catch((err) => {
                    this.caricamento_dati = false;
                    // Stampo una snackbar di avviso.
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    ); // Stampo il log dell'errore in console.
                    console.error(err);
                    return false;
                });
        },

        async getMacchinaElementi() {
            
            const request = {
                controller: "magazzino",
                method: "POST",
                richiesta: {
                    action: "getmacchineelementi",
                    filtri: this.filtri_query,
                    token: localStorage.user_token,
                    id_tipo: this.configurazione_sel.id_tipo,
                },
            };

            this.show_loader = true;
            return this.$store
                .dispatch("api6", request)
                .then((res) => {
                    if (res.data.statusCode === 200) {
                        this.lista_elementi_tipo = res.data.result;
                        return true;
                    } else {
                        this.popup_message = {
                            type: "warning",
                            text: "Errore di comunicazione col server, non è stato possibile caricare i dati.",
                        };
                        console.log("error: " + res.data.statusCode);
                        return false;
                    }
                })
                .catch((err) => {
                    this.caricamento_dati = false;
                    // Stampo una snackbar di avviso.
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    ); // Stampo il log dell'errore in console.
                    console.error(err);
                    return false;
                });
        },

        salvaConfigurazione() {

            let temp_config = [];
            this.lista_report_selezionati.forEach((lr)=>{
                temp_config.push({
                    id_macchina_docs: lr.id_macchina_docs? lr.id_macchina_docs : -moment().valueOf(),
                    id_rif : lr.id_report,
                    id_tipo : this.configurazione_sel.id_tipo,
                    des: lr.cod_report,
                    validita: 1,
        
                });
            });

            this.configurazioni_totali.forEach((ct)=>{
                if(ct.id_tipo == this.configurazione_sel.id_tipo && !this.lista_report_selezionati.find(({id_macchina_docs})=> id_macchina_docs == ct.id_macchina_docs)){
                   ct.validita = 0;
                   temp_config.push(ct);
                }
            });

            let request = {
                method: "PUT",
                controller: "magazzino",
                richiesta: {
                    action: "setmacchinadocs",
                    token: localStorage.user_token,
                    configurazioni: temp_config,
                },
            };

            this.overlay = true;
            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    if (res.status === 200) {
                        this.overlay = false;
                        this.configurazione_sel = {};
                        this.lista_report_selezionati = [];
                        this.dialog_modifica = false;
                        // Stampo una snackbar di conferma
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Salvataggio effettuato!"
                        );

                        // Aggiorno i dati della tabella
                        this.getConfigurazioni();
                    } else {
                        this.overlay = false;
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore nella comunicazione col server."
                        );
                    }
                })
                .catch(() => {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore critico nella comunicazione col server."
                    );
                });
        },
    },

    created() { },
    mounted() {
        this.getConfigurazioni();
        this.getTabelle();
        this.getReport();
    },
};
</script>
<style scoped></style>